//playlists
export const GET_USER_PLAYLISTS = "GET_USER_PLAYLISTS";
export const GET_PLAYLIST_TRACKS = "GET_PLAYLIST_TRACKS";

//token
export const SET_TOKEN_STATUS = "SET_TOKEN_STATUS";

//current music index
export const SET_CURRENT_MUSIC_INDEX = "SET_CURRENT_MUSIC_INDEX";

//search results
export const GET_SEARCH_RESULTS = "GET_SEARCH_RESULTS";

//new releases
export const GET_NEW_RELEASES = "GET_NEW_RELEASES";

//Featured Playlists
export const GET_FEATURED_PLAYLISTS = "GET_FEATURED_PLAYLISTS";

//Album
export const GET_ALBUM_TRACKS = "GET_ALBUM_TRACKS";

//mytopartists
export const GET_MY_TOP_ARTISTS = "GET_MY_TOP_ARTISTS";

//artisttoptracks
export const GET_ARTIST_TOP_TRACKS = "GET_ARTIST_TOP_TRACKS";

//artist
export const GET_ARTIST = "GET_ARTIST";

//mysavedalbums
export const GET_MY_SAVED_ALBUMS = "GET_MY_SAVED_ALBUMS";

//getAlbum
export const GET_ALBUM = "GET_ALBUM";
